import runAction from "../../actions/run-action";
import getOffsetPath from "./offset-path/get-offset-path";
import onModeSwitch from "./on-mode-switch";

/**
 *
 * @param {TemporaryDataProps} data
 * @param {Map<String, any>} properties
 * @param {Boolean} switched
 * @param {Boolean} enter
 * @param {Number} percents
 * @param {Number} progress Global (timeline) progress
 * @param {StepProps} step
 */
const loopProperties = (
  data,
  properties,
  switched,
  enter,
  percents,
  progress,
  step
) => {
  const main = /** @type {MainClassProps} */ (data.get("main"));
  const trigger = /** @type {TriggerProps} */ (data.get("trigger"));
  const timeline = /** @type {TimelineMapProps} */ (data.get("timeline"));

  for (const [parentName, parentProperties] of properties) {
    for (const [propertyName, propertyValue] of parentProperties) {
      /** Current property */
      const property = /** @type {PropertyValueProps} */ (propertyValue);

      /** `!important` priority */
      const priority = property.get("priority");

      const isOffsetPath = trigger.get("has-offset-path");

      /** On trigger mode switch on property-level */
      onModeSwitch(timeline, property, switched, enter);

      // if (priority) {
      //   actives.get(parentName).get(propertyName)[2] = status;
      // }

      if ((enter && (percents === 0 || percents > 1)) || (!enter && switched)) {
        if (property.get("is-action")) {
          runAction(property, main, timeline, step, enter);
        }
      }

      const pure = /** @type {Array<PropertyPureProps>} */ (
        property.get("pure")
      );

      for (const value of pure) {
        if (isOffsetPath) {
          getOffsetPath(main, property, propertyName, value, progress);
        } else {
          value.set("progress", progress);
        }
      }
    }
  }
};

export default loopProperties;
